import { call, put, takeLatest, } from 'redux-saga/effects';

import * as types from './types';
import { fetchExamples as actions, } from './actions';

export {
    actions,
};

const getExamples = () => new Promise(
    resolve => setTimeout(
        () => resolve([ 1, 2, 3, 4, 5, 6, 7, 8 ]),
        1000
    )
);

function* fetchExamples() {
    try {
        const examples = yield call(getExamples);

        yield put(actions.success(examples));
    } catch (error) {
        yield put(actions.failure(error.message));
    }
}

function* examplesSaga() {
    yield takeLatest(types.FETCH_EXAMPLES_REQUEST, fetchExamples);
}

export default examplesSaga;
